import { Component, Host, h, Prop } from '@stencil/core';

/**
 * Used in <hp6-label-decorator />
 *
 * @description form-kit: hp6-field-optional indicates if a field is optional.  Derived from label-decorator specs.
 *
 * @use
 * @version figma-v1
 * @formkit
 * @since 6.0.0
 *
 */
@Component({
  tag: 'hp6-field-optional',
  styleUrl: 'field-optional.scss',
  shadow: true,
})
export class FieldOptional {
  /**
   * The text to be displayed
   */
  @Prop() text: string = 'optional';

  render() {
    const { text } = this;

    return (
      <Host>
        <span>
          (
          {text}
          )
        </span>
      </Host>
    );
  }
}
